module.exports = __webpack_public_path__ + "img/ic_notice_arrow.a1c55d79.svg";